import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CpeConfigurations' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        marginTop: 48
    },
    title: {
        margin: 0,
        color: '#232323',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%'
    }
});
